import { CurrentAudio } from './types';

export const SKIP_SECONDS = 15;
export const SECONDS_PER_MINUTE = 60;
export const MIN_SEEK_VALUE = 0;

export const INITIAL_AUDIO_STATE: CurrentAudio = {
	element: null,
	title: '',
	isPlaying: false,
	currentTime: 0,
	duration: 0,
	thumbnailUrl: undefined,
	programTitle: undefined,
};
